export function mapObject<T, K>(obj: Record<string, T>, callback: (value: T) => K): Record<string, K> {
  return Object.keys(obj).reduce(
    (acc, key) => ({
      ...acc,
      [key]: callback(obj[key]),
    }),
    {} as Record<string, K>
  );
}
